import {
  ApplicantV2Dto,
  ApplicationAcceptedTsCsAuditV2Dto,
  ApplicationV2Dto,
  ApplicationQuestionResponseV2Dto,
  ApplicationsV2Api,
  Configuration,
  CreateApplicationV2Dto,
  UpdateApplicationV2Dto,
  UpsertApplicantV2Dto,
  ApplicationTsCsDto,
  ApplicationsV1Api,
  ReadDocumentDto,
  UpsertApplicantEmploymentHistoryV2Dto,
  ApplicantEmploymentHistoryV2Dto,
  UpsertApplicantRentalHistoryV2Dto,
  ApplicantRentalHistoryV2Dto,
  UpsertApplicantMinorV2Dto,
  ApplicantMinorV2Dto,
  UpsertApplicationPetV2Dto,
  ApplicantPetV2Dto,
  ApplicantVehicleV2Dto,
  UpsertApplicantVehicleV2Dto,
  ApplicationInviteeDetailV2Dto,
  ApplicationSummaryDto,
  UpdateApplicantStatusDto,
  UpdateApplicantStatusResponseDto,
} from '@inosio/payments-sdk';
import { AxiosResponse } from 'axios';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { IpaUserExtended, selectCurrentUser } from '../../../../shared/sagas/auth/authSlice';
import {
  addAcceptedTCsToJsonV2,
  createApplicantV2,
  createApplicationV2,
  createEmploymentIncomeRecord,
  createEmploymentIncomeRecordError,
  createMinorRecord,
  createMinorRecordError,
  getApplicantV2,
  setAddAcceptedTCsToJsonV2,
  setAddAcceptedTCsToJsonErrorV2,
  setApplicantV2,
  setApplicantV2Error,
  setCreateApplicantV2,
  setCreateApplicantV2Error,
  setCreateApplicationV2,
  setCreateApplicationV2Error,
  setUpdateApplicantV2,
  setUpdateApplicantV2Error,
  setUpdateEmploymentIncomeRecord,
  setUpdateMinorRecord,
  updateApplicantV2,
  getApplicationAcceptedTCsV2,
  setApplicationAcceptedTCsV2,
  setApplicationAcceptedTCsErrorV2,
  updateApplicationV2,
  setUpdateApplicationV2,
  setUpdateApplicationErrorV2,
  setCustomQuestionsAnswersV2,
  setCustomQuestionsAnswersV2Error,
  getCustomQuestionsAnswersV2,
  updateCustomQuestionsAnswersV2,
  setOrganizationApplicationTCs,
  setOrganizationApplicationTCsError,
  getOrganizationApplicationTCs,
  getDocuments,
  setDocuments,
  getDocumentsError,
  setEmploymentIncomeRecords,
  getEmploymentIncomeRecordsError,
  setDeleteEmploymentIncomeRecord,
  getDeleteEmploymentIncomeRecordError,
  setCreateEmploymentIncomeRecord,
  getEmploymentIncomeRecords,
  getDeleteEmploymentIncomeRecord,
  setCreateRentalHistoryRecord,
  setCreateRentalHistoryRecordError,
  createRentalHistoryRecord,
  getAllRentalHistoryRecords,
  setAllRentalHistoryRecords,
  setFetchAllRentalHistoryRecordsError,
  updateEmploymentIncomeRecord,
  updateEmploymentIncomeRecordError,
  getRentalHistoryRecord,
  setRentalHistoryRecord,
  setFetchRentalHistoryRecordError,
  deleteRentalHistoryRecord,
  setDeleteRentalHistoryRecord,
  setDeleteRentalHistoryRecordError,
  updateRentalHistoryRecord,
  setUpdateRentalHistoryRecord,
  setUpdateRentalHistoryRecordError,
  setApplicationV2,
  setApplicationV2Error,
  setMinorRecords,
  getMinorRecordsError,
  setDeleteMinorRecord,
  deleteMinorRecordError,
  setCreateMinorRecord,
  updateMinorRecordError,
  getMinorRecords,
  deleteMinorRecord,
  updateMinorRecord,
  getApplicationV2,
  createApplicantPetRecord,
  setCreateApplicantPetRecord,
  setCreateApplicantPetRecordError,
  getApplicantAllPetRecords,
  setApplicantAllPetRecords,
  setFetchApplicantAllPetRecordsError,
  getApplicantPetRecord,
  setApplicantPetRecord,
  setFetchApplicantlPetRecordError,
  deleteApplicantPetRecord,
  setDeleteApplicantPetRecord,
  setDeleteApplicantPetRecordError,
  updateApplicantPetRecord,
  setUpdateApplicantPetRecord,
  setUpdateApplicantPetRecordError,
  createApplicantVehicleRecord,
  setApplicantVehicleRecord,
  setCreateApplicantVehicleRecordError,
  getApplicantAllVehicleRecords,
  setApplicantAllVehicleRecords,
  setFetchApplicantAllVehicleRecordsError,
  getApplicantVehicleRecord,
  setFetchApplicantVehicleRecordError,
  setCreateApplicantVehicleRecord,
  deleteApplicantVehicleRecord,
  setDeleteApplicantVehicleRecord,
  setDeleteApplicantVehicleRecordError,
  updateApplicantVehicleRecord,
  setUpdateApplicantVehicleRecord,
  setUpdateApplicantVehicleRecordError,
  removeApplicantV2,
  getApplicationIntiteeInfoV2,
  inviteApplicantV2,
  setRemoveApplicantV2,
  setRemoveApplicantV2Error,
  setApplicationIntiteeInfoV2Error,
  setApplicationIntiteeInfoV2,
  setInviteApplicantV2,
  setInviteApplicantV2Error,
  updateApplicantStatus,
  setUpdateApplicantStatus,
  setUpdateApplicantStatusError,
  setFetchedApplications,
  setFetchApplicationsError,
  fetchApplications,
} from './applicantsSlice';

/**
 * This saga is intended to be used solely for the applicants flow.
 * There should be no PM UI functionality coming through this at all.
 */

const { REACT_APP_IPA_BASE_PATH } = process.env;
const apiConfig = new Configuration({
  basePath: REACT_APP_IPA_BASE_PATH,
});

function requestUpdateApplicantVehicleRecord(accessToken: string, applicantUuid: string, vehicleUuid: string, updateDto: UpsertApplicantVehicleV2Dto) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsV2API = new ApplicationsV2Api(apiConfig);
  return ipaApplicationsV2API.updateVehicleV2(applicantUuid, vehicleUuid, updateDto);
}

function requestDeleteApplicantVehicleRecord(accessToken: string, applicantUuid: string, vehicleUuid: string) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsV2API = new ApplicationsV2Api(apiConfig);
  return ipaApplicationsV2API.deleteVehicleV2(applicantUuid, vehicleUuid);
}

function requestFetchApplicantVehicleRecord(accessToken: string, applicantUuid: string, vehicleUuid: string) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsV2API = new ApplicationsV2Api(apiConfig);
  return ipaApplicationsV2API.getVehicle2(applicantUuid, vehicleUuid);
}

function requestFetchApplicantAllVehicleRecords(accessToken: string, applicantUuid: string) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsV2API = new ApplicationsV2Api(apiConfig);
  return ipaApplicationsV2API.getVehiclesV2(applicantUuid);
}

function requestCreateApplicantVehicleRecord(accessToken: string, applicantUuid: string, createVehicleDto: UpsertApplicantVehicleV2Dto) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsV2API = new ApplicationsV2Api(apiConfig);
  return ipaApplicationsV2API.createVehicleV2(applicantUuid, createVehicleDto);
}

//
function requestUpdateApplicantPetRecord(accessToken: string, applicantUuid: string, petUuid: string, updateDto: UpsertApplicationPetV2Dto) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsV2API = new ApplicationsV2Api(apiConfig);
  return ipaApplicationsV2API.updatePetV2(applicantUuid, petUuid, updateDto);
}

function requestDeleteApplicantPetRecord(accessToken: string, applicantUuid: string, petUuid: string) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsV2API = new ApplicationsV2Api(apiConfig);
  return ipaApplicationsV2API.deletePetV2(applicantUuid, petUuid);
}

function requestFetchApplicantPetRecord(accessToken: string, applicantUuid: string, petUuid: string) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsV2API = new ApplicationsV2Api(apiConfig);
  return ipaApplicationsV2API.getPetV2(applicantUuid, petUuid);
}
function requestFetchApplicantAllPetRecords(accessToken: string, applicantUuid: string) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsV2API = new ApplicationsV2Api(apiConfig);
  return ipaApplicationsV2API.getAllPetsV2(applicantUuid);
}

function requestCreateApplicantPetRecord(accessToken: string, applicantUuid: string, createPetDto: UpsertApplicationPetV2Dto) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsV2API = new ApplicationsV2Api(apiConfig);
  return ipaApplicationsV2API.createPetV2(applicantUuid, createPetDto);
}

function requestUpdateRentalHistoryRecord(accessToken: string, applicantUuid: string, rentalHistoryUuid: string, upsertDto: UpsertApplicantRentalHistoryV2Dto) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsV2API = new ApplicationsV2Api(apiConfig);
  return ipaApplicationsV2API.updateRentalHistoryV2(applicantUuid, rentalHistoryUuid, upsertDto);
}

function requestDeleteRentalHistoryRecord(accessToken: string, applicantUuid: string, rentalHistoryUuid: string) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsV2API = new ApplicationsV2Api(apiConfig);
  return ipaApplicationsV2API.deleteRentalHistoryV2(applicantUuid, rentalHistoryUuid);
}

function requestGetRentalHistoryRecord(accessToken: string, applicantUuid: string, rentalHistoryUuid: string) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsV2API = new ApplicationsV2Api(apiConfig);
  return ipaApplicationsV2API.getRentalHistoryV2(applicantUuid, rentalHistoryUuid);
}

function requestGetAllRentalHistoryRecords(accessToken: string, applicantUuid: string) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsV2API = new ApplicationsV2Api(apiConfig);
  return ipaApplicationsV2API.getAllRentalHistoriesV2(applicantUuid);
}

function requestCreateRentalHistoryRecord(accessToken: string, applicantUuid: string, createRentalHistoryDto: UpsertApplicantRentalHistoryV2Dto) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsV2API = new ApplicationsV2Api(apiConfig);
  return ipaApplicationsV2API.createRentalHistoryV2(applicantUuid, createRentalHistoryDto);
}

function requestCreateEmploymentIncomeRecord(accessToken: string, applicantUuid: string, newEmploymentDto: UpsertApplicantEmploymentHistoryV2Dto) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsV2API = new ApplicationsV2Api(apiConfig);
  return ipaApplicationsV2API.createEmploymentV2(applicantUuid, newEmploymentDto);
}

function requestGetDocuments(accessToken: string, applicantUuid: string) {
  const apiConfig = new Configuration({
    basePath: REACT_APP_IPA_BASE_PATH,
    accessToken,
  });

  const ipaApplicationsApiV2 = new ApplicationsV2Api(apiConfig);
  return ipaApplicationsApiV2.getApplicantDocumentsV2(applicantUuid);
}

function requestOrganizationApplicationTCs(accessToken: string, organizationUuid: string) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsAPI = new ApplicationsV1Api(apiConfig);
  return ipaApplicationsAPI.getOrganizationApplicationTerms(organizationUuid);
}

function requestUpdateApplicationV2(access_token: string, applicationUuid: string, updateApplicationDto: UpdateApplicationV2Dto) {
  apiConfig.accessToken = access_token;
  const ipaApplicationsApiV2 = new ApplicationsV2Api(apiConfig);
  return ipaApplicationsApiV2.updateApplicationV2(applicationUuid, updateApplicationDto);
}

function requestGetAcceptedTCsV2(access_token: string, applicationUuid: string, applicantUuid: string) {
  apiConfig.accessToken = access_token;
  const ipaApplicationsApiV2 = new ApplicationsV2Api(apiConfig);
  return ipaApplicationsApiV2.getAcceptedTsCs(applicationUuid, applicantUuid);
}

function requestAddAcceptedTCsToJsonV2(access_token: string, applicationUuid: string, addAcceptedTCsToJsonDto: ApplicationAcceptedTsCsAuditV2Dto) {
  apiConfig.accessToken = access_token;
  const ipaApplicationsApiV2 = new ApplicationsV2Api(apiConfig);
  return ipaApplicationsApiV2.addAcceptedTsCs(applicationUuid, addAcceptedTCsToJsonDto);
}

function requestGetApplicantV2(access_token: string, applicantUuid: string) {
  apiConfig.accessToken = access_token;
  const ipaApplicationsApiV2 = new ApplicationsV2Api(apiConfig);
  return ipaApplicationsApiV2.getApplicantV2(applicantUuid);
}

function createApplicantApiRequest(access_token: string, newApplicantDto: UpsertApplicantV2Dto, inviteToApplicationUuid?: string) {
  apiConfig.accessToken = access_token;
  const ipaApplicationsApiV2 = new ApplicationsV2Api(apiConfig);
  return ipaApplicationsApiV2.createApplicantV2(newApplicantDto, inviteToApplicationUuid);
}

function requestGetInviteeInfo(applicationUuid: string, coapplicantUuid: string, hmac: string) {
  const ipaApplicationsApiV2 = new ApplicationsV2Api(apiConfig);
  return ipaApplicationsApiV2.getApplicationInvitationDetail(applicationUuid, coapplicantUuid, hmac);
}

function requestDeleteApplicantRecord(accessToken: string, applicantUuid: string, applicationUuid: string) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsV2API = new ApplicationsV2Api(apiConfig);
  return ipaApplicationsV2API.deleteApplicantV2(applicantUuid, applicationUuid);
}

function updateApplicantApiRequest(access_token: string, applicantUuid: string, updateApplicantDto: UpsertApplicantV2Dto) {
  apiConfig.accessToken = access_token;
  const ipaApplicationsApiV2 = new ApplicationsV2Api(apiConfig);
  return ipaApplicationsApiV2.updateApplicantV2(applicantUuid, updateApplicantDto);
}

function createApplicationApiRequest(access_token: string, newApplicationDto: CreateApplicationV2Dto) {
  apiConfig.accessToken = access_token;
  const ipaApplicationsApiV2 = new ApplicationsV2Api(apiConfig);
  return ipaApplicationsApiV2.createApplicationV2(newApplicationDto);
}

function requestGetApplication(accessToken: string, applicationUuid: string) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsV2API = new ApplicationsV2Api(apiConfig);
  return ipaApplicationsV2API.getApplicationV2(applicationUuid);
}

function requestGetCustomQuestionsAnswers(accessToken: string, applicationUuid: string, applicantUuid: string) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsV2API = new ApplicationsV2Api(apiConfig);
  return ipaApplicationsV2API.getCustomQuestionAnswers(applicationUuid, applicantUuid);
}

function upsertCustomQuestionApiRequest(access_token: string, applicationUuid: string, customQuestionDto: ApplicationQuestionResponseV2Dto) {
  apiConfig.accessToken = access_token;
  const ipaApplicationsApiV2 = new ApplicationsV2Api(apiConfig);
  return ipaApplicationsApiV2.addCustomQuestionAnswers(applicationUuid, customQuestionDto);
}

function requestGetEmploymentIncomeRecords(accessToken: string, applicantUuid: string) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsV2API = new ApplicationsV2Api(apiConfig);
  return ipaApplicationsV2API.getEmploymentsV2(applicantUuid);
}

function requestDeleteMinorRecord(accessToken: string, applicantUuid: string, minorUuid: string) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsV2API = new ApplicationsV2Api(apiConfig);
  return ipaApplicationsV2API.deleteMinorV2(applicantUuid, minorUuid);
}

function requestCreateMinorRecord(accessToken: string, applicantUuid: string, newMinorDto: UpsertApplicantMinorV2Dto) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsV2API = new ApplicationsV2Api(apiConfig);
  return ipaApplicationsV2API.createMinorV2(applicantUuid, newMinorDto);
}

function requestUpdateMinorRecord(accessToken: string, applicantUuid: string, minorUuid: string, updateMinorDto: UpsertApplicantMinorV2Dto) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsV2API = new ApplicationsV2Api(apiConfig);
  return ipaApplicationsV2API.updateMinorV2(applicantUuid, minorUuid, updateMinorDto);
}

function requestGetMinorRecords(accessToken: string, applicantUuid: string) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsV2API = new ApplicationsV2Api(apiConfig);
  return ipaApplicationsV2API.getMinorsV2(applicantUuid);
}

function requestDeleteEmploymentIncomeRecord(accessToken: string, applicantUuid: string, employmentUuid: string) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsV2API = new ApplicationsV2Api(apiConfig);
  return ipaApplicationsV2API.deleteEmploymentV2(applicantUuid, employmentUuid);
}

function requestUpdateEmploymentIncomeRecord(accessToken: string, applicantUuid: string, employmentUuid: string, updateEmploymentDto: UpsertApplicantEmploymentHistoryV2Dto) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsV2API = new ApplicationsV2Api(apiConfig);
  return ipaApplicationsV2API.updateEmploymentV2(applicantUuid, employmentUuid, updateEmploymentDto);
}

function requestUpdateApplicantStatus(accessToken: string, applicationUuid: string, applicantUuid: string, updateApplicantStatusDto: UpdateApplicantStatusDto) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsV2API = new ApplicationsV2Api(apiConfig);
  return ipaApplicationsV2API.updateApplicantStatusV2(applicationUuid, applicantUuid, updateApplicantStatusDto);
}

function requestFetchApplications(accessToken: string, applicantUuid: string) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsV2API = new ApplicationsV2Api(apiConfig);
  return ipaApplicationsV2API.getApplicantApplicationsV2(applicantUuid);
}

function* handleFetchOrganizationApplicationTCs(action: { type: typeof getOrganizationApplicationTCs; payload: { organizationUuid: string } }) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<ApplicationTsCsDto> = yield call(requestOrganizationApplicationTCs, currentUser.accessToken, action.payload.organizationUuid);
    const { data } = response;
    yield put(setOrganizationApplicationTCs(data));
  } catch (error: any) {
    yield put(setOrganizationApplicationTCsError({ ...error?.response?.data }));
  }
}

function* handleUpdateApplicationV2(action: { type: typeof updateApplicationV2; payload: { applicationUuid: string; updateDto: UpdateApplicationV2Dto } }) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    yield call(requestUpdateApplicationV2, currentUser.accessToken, action.payload.applicationUuid, action.payload.updateDto);

    yield put(setUpdateApplicationV2());
  } catch (error: any) {
    yield put(setUpdateApplicationErrorV2({ ...error?.response?.data }));
  }
}

function* handleGetApplicationAcceptedTCsV2(action: { type: typeof getApplicationAcceptedTCsV2; payload: { applicationUuid: string; applicantUuid: string } }) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<ApplicationAcceptedTsCsAuditV2Dto[]> = yield call(requestGetAcceptedTCsV2, currentUser.accessToken, action.payload.applicationUuid, action.payload.applicantUuid);

    const { data } = response;
    yield put(setApplicationAcceptedTCsV2(data));
  } catch (error: any) {
    yield put(setApplicationAcceptedTCsErrorV2({ ...error?.response?.data }));
  }
}

function* handleAddAcceptedTCsToJsonV2(action: { type: typeof addAcceptedTCsToJsonV2; payload: { applicationUuid: string; addAcceptedTCsToJsonDto: ApplicationAcceptedTsCsAuditV2Dto } }) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    yield call(requestAddAcceptedTCsToJsonV2, currentUser.accessToken, action.payload.applicationUuid, action.payload.addAcceptedTCsToJsonDto);

    yield put(setAddAcceptedTCsToJsonV2());
  } catch (error: any) {
    yield put(setAddAcceptedTCsToJsonErrorV2({ ...error?.response?.data }));
  }
}

function* handleGetApplicantV2(action: { type: typeof getApplicantV2 }) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<ApplicantV2Dto[]> = yield call(requestGetApplicantV2, currentUser.accessToken, currentUser.currentProfile.uuid);

    const { data } = response;
    yield put(setApplicantV2(data));
  } catch (error: any) {
    yield put(setApplicantV2Error({ ...error?.response?.data }));
  }
}

function* handleCreateApplicantV2(action: { type: typeof createApplicantV2; payload: { applicantDto: UpsertApplicantV2Dto } }) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<ApplicantV2Dto[]> = yield call(createApplicantApiRequest, currentUser.accessToken, action.payload.applicantDto);

    const { data } = response;
    yield put(setCreateApplicantV2(data));
  } catch (error: any) {
    yield put(setCreateApplicantV2Error({ ...error?.response?.data }));
  }
}

function* handleInviteApplicantV2(action: { type: typeof createApplicantV2; payload: { applicantDto: UpsertApplicantV2Dto; inviteToApplicationUuid: string } }) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<ApplicantV2Dto[]> = yield call(createApplicantApiRequest, currentUser.accessToken, action.payload.applicantDto, action.payload.inviteToApplicationUuid);

    const { data } = response;
    yield put(setInviteApplicantV2(data));
  } catch (error: any) {
    yield put(setInviteApplicantV2Error({ ...error?.response?.data }));
  }
}

function* handleGetApplicantInvitationV2(action: { type: typeof getApplicationIntiteeInfoV2; payload: { applicationUuid: string; coapplicantUuid: string; hmac: string } }) {
  try {
    const { applicationUuid, coapplicantUuid, hmac } = action.payload;
    const response: AxiosResponse<ApplicationInviteeDetailV2Dto> = yield call(requestGetInviteeInfo, applicationUuid, coapplicantUuid, hmac);

    const { data } = response;
    yield put(setApplicationIntiteeInfoV2(data));
  } catch (error: any) {
    yield put(setApplicationIntiteeInfoV2Error({ ...error?.response?.data }));
  }
}

function* handleRemoveApplicantV2(action: { type: typeof removeApplicantV2; payload: { applicationUuid: string; applicantUuid: string } }) {
  try {
    const { applicationUuid, applicantUuid } = action.payload;
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<void> = yield call(requestDeleteApplicantRecord, currentUser.accessToken, applicantUuid, applicationUuid);

    const { data } = response;
    yield put(setRemoveApplicantV2(data));
  } catch (error: any) {
    yield put(setRemoveApplicantV2Error({ ...error?.response?.data }));
  }
}

function* handleUpdateApplicantV2(action: { type: typeof updateApplicantV2; payload: { applicantUuid: string; updateDto: UpsertApplicantV2Dto } }) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<ApplicantV2Dto[]> = yield call(updateApplicantApiRequest, currentUser.accessToken, action.payload.applicantUuid, action.payload.updateDto);

    const { data } = response;
    yield put(setUpdateApplicantV2(data));
  } catch (error: any) {
    yield put(setUpdateApplicantV2Error({ ...error?.response?.data }));
  }
}

function* handleCreateApplicationV2(action: { type: typeof createApplicationV2; payload: CreateApplicationV2Dto }) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<ApplicationV2Dto[]> = yield call(createApplicationApiRequest, currentUser.accessToken, action.payload);

    const { data } = response;
    yield put(setCreateApplicationV2(data));
  } catch (error: any) {
    yield put(setCreateApplicationV2Error({ ...error?.response?.data }));
  }
}

function* handleGetApplication(action: any) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<ApplicationV2Dto> = yield call(requestGetApplication, currentUser.accessToken, action.payload);
    const { data } = response;
    yield put(setApplicationV2(data));
  } catch (error: any) {
    yield put(setApplicationV2Error({ ...error?.response?.data }));
  }
}

function* handleGetCustomQuestionsAnswersApplication(action: any) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<ApplicationQuestionResponseV2Dto> = yield call(
      requestGetCustomQuestionsAnswers,
      currentUser.accessToken,
      action.payload.applicationUuid,
      action.payload.applicantUuid,
    );
    const { data } = response;
    yield put(setCustomQuestionsAnswersV2(data));
  } catch (error: any) {
    yield put(setCustomQuestionsAnswersV2Error({ ...error?.response?.data }));
  }
}

function* handleUpsertCustomQuestionsAnswersV2(action: { type: typeof updateCustomQuestionsAnswersV2; payload: { applicationUuid: string; upsertDto: ApplicationQuestionResponseV2Dto } }) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<void> = yield call(upsertCustomQuestionApiRequest, currentUser.accessToken, action.payload.applicationUuid, action.payload.upsertDto);

    const { data } = response;
    yield put(setUpdateApplicantV2(data));
  } catch (error: any) {
    yield put(setUpdateApplicantV2Error({ ...error?.response?.data }));
  }
}

function* handleGetDocuments(action: any) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const getDocumentsResponse: AxiosResponse<ReadDocumentDto[]> = yield call(requestGetDocuments, currentUser.accessToken, action.payload.applicantUuid);
    const { data } = getDocumentsResponse;

    yield put(setDocuments(data));
  } catch (error: any) {
    yield put(getDocumentsError({ ...error?.response?.data }));
  }
}

function* handleGetEmploymentIncomeRecords(action: any) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const getEmploymentsResponse: AxiosResponse<ApplicantEmploymentHistoryV2Dto[]> = yield call(requestGetEmploymentIncomeRecords, currentUser.accessToken, action.payload);
    const { data } = getEmploymentsResponse;

    yield put(setEmploymentIncomeRecords(data));
  } catch (error: any) {
    yield put(getEmploymentIncomeRecordsError({ ...error?.response?.data }));
  }
}

function* handleDeleteEmploymentIncomeRecord(action: any) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const deleteEmploymentResponse: AxiosResponse<void> = yield call(requestDeleteEmploymentIncomeRecord, currentUser.accessToken, action.payload.applicantUuid, action.payload.employmentUuid);
    const { data } = deleteEmploymentResponse;

    yield put(setDeleteEmploymentIncomeRecord(data));
  } catch (error: any) {
    yield put(getDeleteEmploymentIncomeRecordError({ ...error?.response?.data }));
  }
}

function* handleCreateEmploymentIncomeRecord(action: any) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const createEmploymentsResponse: AxiosResponse<ApplicantEmploymentHistoryV2Dto> = yield call(
      requestCreateEmploymentIncomeRecord,
      currentUser.accessToken,
      action.payload.applicantUuid,
      action.payload.employmentDto,
    );
    const { data } = createEmploymentsResponse;

    yield put(setCreateEmploymentIncomeRecord(data));
  } catch (error: any) {
    yield put(createEmploymentIncomeRecordError({ ...error?.response?.data }));
  }
}

function* handleCreateRentalHistoryRecord(action: { type: typeof createRentalHistoryRecord; payload: { applicantUuid: string; upsertRentalHistoryDto: UpsertApplicantRentalHistoryV2Dto } }) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const createRentalHistoryResponse: AxiosResponse<ApplicantRentalHistoryV2Dto> = yield call(
      requestCreateRentalHistoryRecord,
      currentUser.accessToken,
      action.payload.applicantUuid,
      action.payload.upsertRentalHistoryDto,
    );
    const { data } = createRentalHistoryResponse;

    yield put(setCreateRentalHistoryRecord(data));
  } catch (error: any) {
    yield put(setCreateRentalHistoryRecordError({ ...error?.response?.data }));
  }
}

function* handleDeleteRentalHistoryRecord(action: { type: typeof deleteRentalHistoryRecord; payload: { applicantUuid: string; rentalHistoryUuid: string } }) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    yield call(requestDeleteRentalHistoryRecord, currentUser.accessToken, action.payload.applicantUuid, action.payload.rentalHistoryUuid);

    yield put(setDeleteRentalHistoryRecord());
  } catch (error: any) {
    yield put(setDeleteRentalHistoryRecordError({ ...error?.response?.data }));
  }
}

function* handleGetAllRentalHistoryRecords(action: { type: typeof getAllRentalHistoryRecords; payload: { applicantUuid: string } }) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const getAllRentalHistoriesResponse: AxiosResponse<ApplicantRentalHistoryV2Dto[]> = yield call(requestGetAllRentalHistoryRecords, currentUser.accessToken, action.payload.applicantUuid);
    const { data } = getAllRentalHistoriesResponse;

    yield put(setAllRentalHistoryRecords(data));
  } catch (error: any) {
    yield put(setFetchAllRentalHistoryRecordsError({ ...error?.response?.data }));
  }
}

function* handleGetRentalHistoryRecord(action: { type: typeof getRentalHistoryRecord; payload: { applicantUuid: string; rentalHistoryUuid: string } }) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const getRentalHistoryResponse: AxiosResponse<ApplicantRentalHistoryV2Dto> = yield call(
      requestGetRentalHistoryRecord,
      currentUser.accessToken,
      action.payload.applicantUuid,
      action.payload.rentalHistoryUuid,
    );
    const { data } = getRentalHistoryResponse;

    yield put(setRentalHistoryRecord(data));
  } catch (error: any) {
    yield put(setFetchRentalHistoryRecordError({ ...error?.response?.data }));
  }
}

function* handleUpdateRentalHistoryRecord(action: {
  type: typeof updateRentalHistoryRecord;
  payload: { applicantUuid: string; rentalHistoryUuid: string; updateDto: UpsertApplicantRentalHistoryV2Dto };
}) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const updateRentalResponse: AxiosResponse<void> = yield call(
      requestUpdateRentalHistoryRecord,
      currentUser.accessToken,
      action.payload.applicantUuid,
      action.payload.rentalHistoryUuid,
      action.payload.updateDto,
    );
    const { data } = updateRentalResponse;
    yield put(setUpdateRentalHistoryRecord(data));
  } catch (error: any) {
    yield put(setUpdateRentalHistoryRecordError({ ...error?.response?.data }));
  }
}

function* handleUpdateEmploymentIncomeRecord(action: any) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const updateEmploymentsResponse: AxiosResponse<void> = yield call(
      requestUpdateEmploymentIncomeRecord,
      currentUser.accessToken,
      action.payload.applicantUuid,
      action.payload.employmentUuid,
      action.payload.updateDto,
    );
    const { data } = updateEmploymentsResponse;

    yield put(setUpdateEmploymentIncomeRecord(data));
  } catch (error: any) {
    yield put(updateEmploymentIncomeRecordError({ ...error?.response?.data }));
  }
}

function* handleGetMinorRecords(action: any) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const getEmploymentsResponse: AxiosResponse<ApplicantMinorV2Dto[]> = yield call(requestGetMinorRecords, currentUser.accessToken, action.payload);
    const { data } = getEmploymentsResponse;

    yield put(setMinorRecords(data));
  } catch (error: any) {
    yield put(getMinorRecordsError({ ...error?.response?.data }));
  }
}

function* handleDeleteMinorRecord(action: any) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const deleteEmploymentResponse: AxiosResponse<void> = yield call(requestDeleteMinorRecord, currentUser.accessToken, action.payload.applicantUuid, action.payload.minorUuid);
    const { data } = deleteEmploymentResponse;

    yield put(setDeleteMinorRecord(data));
  } catch (error: any) {
    yield put(deleteMinorRecordError({ ...error?.response?.data }));
  }
}

function* handleCreateMinorRecord(action: any) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const createEmploymentsResponse: AxiosResponse<ApplicantMinorV2Dto> = yield call(requestCreateMinorRecord, currentUser.accessToken, action.payload.applicantUuid, action.payload.minorDto);
    const { data } = createEmploymentsResponse;

    yield put(setCreateMinorRecord(data));
  } catch (error: any) {
    yield put(createMinorRecordError({ ...error?.response?.data }));
  }
}

function* handleUpdateMinorRecord(action: any) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const updateEmploymentsResponse: AxiosResponse<void> = yield call(
      requestUpdateMinorRecord,
      currentUser.accessToken,
      action.payload.applicantUuid,
      action.payload.minorUuid,
      action.payload.updateDto,
    );
    const { data } = updateEmploymentsResponse;

    yield put(setUpdateMinorRecord(data));
  } catch (error: any) {
    yield put(updateMinorRecordError({ ...error?.response?.data }));
  }
}

function* handleCreateApplicantPetRecord(action: { type: typeof createApplicantPetRecord; payload: { applicantUuid: string; createPetDto: UpsertApplicationPetV2Dto } }) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const createPetResponse: AxiosResponse<ApplicantPetV2Dto> = yield call(requestCreateApplicantPetRecord, currentUser.accessToken, action.payload.applicantUuid, action.payload.createPetDto);
    const { data } = createPetResponse;

    yield put(setCreateApplicantPetRecord(data));
  } catch (error: any) {
    yield put(setCreateApplicantPetRecordError({ ...error?.response?.data }));
  }
}

function* handleFetchApplicantAllPetRecords(action: { type: typeof getApplicantAllPetRecords; payload: { applicantUuid: string } }) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const fetchAllPetsResponse: AxiosResponse<ApplicantPetV2Dto[]> = yield call(requestFetchApplicantAllPetRecords, currentUser.accessToken, action.payload.applicantUuid);
    const { data } = fetchAllPetsResponse;

    yield put(setApplicantAllPetRecords(data));
  } catch (error: any) {
    yield put(setFetchApplicantAllPetRecordsError({ ...error?.response?.data }));
  }
}

function* handleFetchApplicantPetRecord(action: { type: typeof getApplicantPetRecord; payload: { applicantUuid: string; petUuid: string } }) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const fetchPetResponse: AxiosResponse<ApplicantPetV2Dto> = yield call(requestFetchApplicantPetRecord, currentUser.accessToken, action.payload.applicantUuid, action.payload.petUuid);
    const { data } = fetchPetResponse;

    yield put(setApplicantPetRecord(data));
  } catch (error: any) {
    yield put(setFetchApplicantlPetRecordError({ ...error?.response?.data }));
  }
}

function* handleDeleteApplicantPetRecord(action: { type: typeof deleteApplicantPetRecord; payload: { applicantUuid: string; petUuid: string } }) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    yield call(requestDeleteApplicantPetRecord, currentUser.accessToken, action.payload.applicantUuid, action.payload.petUuid);

    yield put(setDeleteApplicantPetRecord());
  } catch (error: any) {
    yield put(setDeleteApplicantPetRecordError({ ...error?.response?.data }));
  }
}

function* handleUpdateApplicantPetRecord(action: { type: typeof updateApplicantPetRecord; payload: { applicantUuid: string; petUuid: string; updateDto: UpsertApplicationPetV2Dto } }) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    yield call(requestUpdateApplicantPetRecord, currentUser.accessToken, action.payload.applicantUuid, action.payload.petUuid, action.payload.updateDto);

    yield put(setUpdateApplicantPetRecord());
  } catch (error: any) {
    yield put(setUpdateApplicantPetRecordError({ ...error?.response?.data }));
  }
}

//vehicles

function* handleCreateApplicantVehicleRecord(action: { type: typeof createApplicantVehicleRecord; payload: { applicantUuid: string; createVehicleDto: UpsertApplicantVehicleV2Dto } }) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const createVehicleResponse: AxiosResponse<ApplicantVehicleV2Dto> = yield call(
      requestCreateApplicantVehicleRecord,
      currentUser.accessToken,
      action.payload.applicantUuid,
      action.payload.createVehicleDto,
    );
    const { data } = createVehicleResponse;

    yield put(setCreateApplicantVehicleRecord(data));
  } catch (error: any) {
    yield put(setCreateApplicantVehicleRecordError({ ...error?.response?.data }));
  }
}

function* handleFetchApplicantAllVehicleRecords(action: { type: typeof getApplicantAllVehicleRecords; payload: { applicantUuid: string } }) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const fetchAllVehiclesResponse: AxiosResponse<ApplicantVehicleV2Dto[]> = yield call(requestFetchApplicantAllVehicleRecords, currentUser.accessToken, action.payload.applicantUuid);
    const { data } = fetchAllVehiclesResponse;

    yield put(setApplicantAllVehicleRecords(data));
  } catch (error: any) {
    yield put(setFetchApplicantAllVehicleRecordsError({ ...error?.response?.data }));
  }
}

function* handleFetchApplicantVehicleRecord(action: { type: typeof getApplicantVehicleRecord; payload: { applicantUuid: string; vehicleUuid: string } }) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const fetchVehicleResponse: AxiosResponse<ApplicantVehicleV2Dto> = yield call(
      requestFetchApplicantVehicleRecord,
      currentUser.accessToken,
      action.payload.applicantUuid,
      action.payload.vehicleUuid,
    );
    const { data } = fetchVehicleResponse;

    yield put(setApplicantVehicleRecord(data));
  } catch (error: any) {
    yield put(setFetchApplicantVehicleRecordError({ ...error?.response?.data }));
  }
}

function* handleDeleteApplicantVehicleRecord(action: { type: typeof deleteApplicantVehicleRecord; payload: { applicantUuid: string; vehicleUuid: string } }) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    yield call(requestDeleteApplicantVehicleRecord, currentUser.accessToken, action.payload.applicantUuid, action.payload.vehicleUuid);

    yield put(setDeleteApplicantVehicleRecord());
  } catch (error: any) {
    yield put(setDeleteApplicantVehicleRecordError({ ...error?.response?.data }));
  }
}

function* handleUpdateApplicantVehicleRecord(action: { type: typeof updateApplicantVehicleRecord; payload: { applicantUuid: string; vehicleUuid: string; updateDto: UpsertApplicantVehicleV2Dto } }) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    yield call(requestUpdateApplicantVehicleRecord, currentUser.accessToken, action.payload.applicantUuid, action.payload.vehicleUuid, action.payload.updateDto);

    yield put(setUpdateApplicantVehicleRecord());
  } catch (error: any) {
    yield put(setUpdateApplicantVehicleRecordError({ ...error?.response?.data }));
  }
}

function* handleUpdateApplicantStatus(action: { type: typeof updateApplicantStatus; payload: { applicationUuid: string; applicantUuid: string; updateApplicantStatusDto: UpdateApplicantStatusDto } }) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const updateApplicantResponse: AxiosResponse<UpdateApplicantStatusResponseDto> = yield call(
      requestUpdateApplicantStatus,
      currentUser.accessToken,
      action.payload.applicationUuid,
      action.payload.applicantUuid,
      action.payload.updateApplicantStatusDto,
    );

    yield put(setUpdateApplicantStatus(updateApplicantResponse.data));
  } catch (error: any) {
    yield put(setUpdateApplicantStatusError({ ...error?.response?.data }));
  }
}

function* handleFetchApplications(action: { type: typeof fetchApplications; payload: { applicantUuid: string } }) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const searchAppResponse: AxiosResponse<ApplicationSummaryDto> = yield call(requestFetchApplications, currentUser.accessToken, action.payload.applicantUuid);

    yield put(setFetchedApplications(searchAppResponse.data || []));
  } catch (error: any) {
    yield put(setFetchApplicationsError({ ...error?.response?.data }));
  }
}

export default function* applicantsSaga() {
  yield takeLatest(getApplicantV2.type, handleGetApplicantV2);
  yield takeLatest(createApplicantV2.type, handleCreateApplicantV2);
  yield takeLatest(inviteApplicantV2.type, handleInviteApplicantV2);
  yield takeLatest(createApplicationV2.type, handleCreateApplicationV2);
  yield takeLatest(getApplicationIntiteeInfoV2.type, handleGetApplicantInvitationV2);
  yield takeLatest(removeApplicantV2.type, handleRemoveApplicantV2);
  yield takeLatest(updateApplicantV2.type, handleUpdateApplicantV2);
  yield takeLatest(addAcceptedTCsToJsonV2.type, handleAddAcceptedTCsToJsonV2);
  yield takeLatest(getApplicationAcceptedTCsV2.type, handleGetApplicationAcceptedTCsV2);
  yield takeLatest(updateApplicationV2.type, handleUpdateApplicationV2);
  yield takeLatest(getApplicationV2.type, handleGetApplication);
  yield takeLatest(getCustomQuestionsAnswersV2.type, handleGetCustomQuestionsAnswersApplication);
  yield takeLatest(updateCustomQuestionsAnswersV2.type, handleUpsertCustomQuestionsAnswersV2);
  yield takeLatest(getOrganizationApplicationTCs.type, handleFetchOrganizationApplicationTCs);
  yield takeLatest(getDocuments.type, handleGetDocuments);
  yield takeLatest(getEmploymentIncomeRecords.type, handleGetEmploymentIncomeRecords);
  yield takeLatest(getDeleteEmploymentIncomeRecord.type, handleDeleteEmploymentIncomeRecord);
  yield takeLatest(createEmploymentIncomeRecord.type, handleCreateEmploymentIncomeRecord);
  yield takeLatest(createRentalHistoryRecord.type, handleCreateRentalHistoryRecord);
  yield takeLatest(getAllRentalHistoryRecords.type, handleGetAllRentalHistoryRecords);
  yield takeLatest(updateEmploymentIncomeRecord.type, handleUpdateEmploymentIncomeRecord);
  yield takeLatest(getRentalHistoryRecord.type, handleGetRentalHistoryRecord);
  yield takeLatest(deleteRentalHistoryRecord.type, handleDeleteRentalHistoryRecord);
  yield takeLatest(updateRentalHistoryRecord.type, handleUpdateRentalHistoryRecord);
  yield takeLatest(getMinorRecords.type, handleGetMinorRecords);
  yield takeLatest(deleteMinorRecord.type, handleDeleteMinorRecord);
  yield takeLatest(createMinorRecord.type, handleCreateMinorRecord);
  yield takeLatest(updateMinorRecord.type, handleUpdateMinorRecord);
  yield takeLatest(createApplicantPetRecord.type, handleCreateApplicantPetRecord);
  yield takeLatest(getApplicantAllPetRecords.type, handleFetchApplicantAllPetRecords);
  yield takeLatest(getApplicantPetRecord.type, handleFetchApplicantPetRecord);
  yield takeLatest(deleteApplicantPetRecord.type, handleDeleteApplicantPetRecord);
  yield takeLatest(updateApplicantPetRecord.type, handleUpdateApplicantPetRecord);
  yield takeLatest(createApplicantVehicleRecord.type, handleCreateApplicantVehicleRecord);
  yield takeLatest(getApplicantAllVehicleRecords.type, handleFetchApplicantAllVehicleRecords);
  yield takeLatest(getApplicantVehicleRecord.type, handleFetchApplicantVehicleRecord);
  yield takeLatest(deleteApplicantVehicleRecord.type, handleDeleteApplicantVehicleRecord);
  yield takeLatest(updateApplicantVehicleRecord.type, handleUpdateApplicantVehicleRecord);
  yield takeLatest(updateApplicantStatus.type, handleUpdateApplicantStatus);
  yield takeLatest(fetchApplications.type, handleFetchApplications);
}
